import { ICONS } from "../../constants/icons"

export const ADMIN_NAV_ITEMS = [
  {
    key: "dashboard",
    label: "Dashboard",
    to: "/admin/dashboard",
    icon: ICONS.adminDashboard,
  },
  {
    key: "cities",
    label: "Cities",
    to: "/admin/cities",
    icon: ICONS.adminCities,
  },
  {
    key: "projects",
    label: "Projects",
    to: "/admin/projects",
    icon: ICONS.adminProjects,
  },
  {
    key: "sessions",
    label: "Sessions",
    to: "/admin/sessions",
    icon: ICONS.adminSessions,
  },
  {
    key: "members",
    label: "Members",
    to: "/admin/members",
    icon: ICONS.adminMembers,
  },
  {
    key: "rewards",
    label: "Treasure & XP",
    to: "/admin/rewards",
    icon: ICONS.adminRewards,
  },
  {
    key: "inbox",
    label: "Inbox & Calls",
    to: "/admin/inbox",
    icon: ICONS.adminInbox,
  },
  {
    key: "arts-genome",
    label: "Arts Genome",
    to: "/admin/arts-genome",
    icon: ICONS.adminArtsGenome,
  },
  {
    key: "requests",
    label: "Requests",
    to: "/admin/requests",
    icon: ICONS.adminRequests,
  },
  {
    key: "flags",
    label: "Flags & Reports",
    to: "/admin/flags",
    icon: ICONS.adminFlags,
  },
  {
    key: "staff",
    label: "Staff Management",
    to: "/admin/staff",
    icon: ICONS.adminStaff,
  },
  {
    key: "roles",
    label: "Roles & Permissions",
    to: "/admin/roles",
    icon: ICONS.adminRoles,
  },
  {
    key: "settings",
    label: "Settings",
    to: "/admin/settings",
    icon: ICONS.adminSettings,
  },
]

export const ADMIN_SHORTCUTS = [
  {
    key: "add-city",
    label: "Add New City",
    to: "/admin/cities/create",
    module: "cities",
    action: "create",
  },
  {
    key: "add-user",
    label: "Add New User",
    to: "/admin/members?create=1",
    module: "invites",
    action: "create",
    requiresView: "members",
  },
  {
    key: "add-staff",
    label: "Add New Staff",
    to: "/admin/staff?create=1",
    module: "staff",
    action: "create",
    requiresView: "staff",
  },
]
